<div id="wrap">
  <div id="main">
    <header>
      <cfp-login-navbar />
    </header>
    <main id="mainContainer">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1">
            <ng-content />
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
<cfp-login-footer />
